import { render, staticRenderFns } from "./ViewAttachDocument.vue?vue&type=template&id=900a6712"
import script from "./ViewAttachDocument.vue?vue&type=script&lang=js"
export * from "./ViewAttachDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports